import { type ExpandedFieldStateManager } from "./ExpandedFieldStateManager";
import { typeInfoFor } from "./TypeTagInfo";
import { type ValueInspectorRowInfo } from "./ValueInspectorRowInfo";
import { type ValuePath, concatPath } from "./ValuePath";
import { iterateObjectValue } from "./iterateObjectValue";
import { traverseValue } from "./traverseValue";

export function traverseObjectValue(
	fieldExpander: ExpandedFieldStateManager,
	pathToO: ValuePath,
	o: object,
	shallow: boolean
): ValueInspectorRowInfo[] {
	const fields: ValueInspectorRowInfo[] = [];

	for (const [key, value] of iterateObjectValue(o)) {
		const typeInfo = typeInfoFor(value);
		const newPath = concatPath(pathToO, { type: "ObjectField", key, value, typeInfo });

		fields.push(...traverseValue(fieldExpander, newPath, typeInfo, shallow));
	}

	return fields;
}
